import React from 'react';
import {
  Box,
  Column,
  Row,
  SkeletonLoader,
} from '@chargify/custom-ui-components';

const DetailsSectionLoadingSkeleton = () => {
  return (
    <Row rowGap={8}>
      <Column span={[24, 8]}>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={150} />
        </Box>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={120} />
        </Box>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={120} />
        </Box>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={80} />
        </Box>
        <SkeletonLoader height={30} width={200} />
      </Column>
      <Column span={[24, 16]}>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={200} />
        </Box>
        <Box marginBottom={5}>
          <SkeletonLoader height={28} width={120} />
        </Box>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={230} />
        </Box>
        <Box marginBottom={4}>
          <SkeletonLoader height={28} width={300} />
        </Box>
        <SkeletonLoader height={28} width={150} />
      </Column>
    </Row>
  );
};

export default DetailsSectionLoadingSkeleton;
